import { createGlobalStyle } from 'styled-components';
import { variables } from './variables';
import 'antd/dist/antd.css';

export const GlobalStyle = createGlobalStyle`
  :root {
    font-size: 8px;
  }
  body {
    margin: 0;
    line-height: 1.7;
    font: 400 2rem "Open Sans", sans-serif;
  }
  @page {
    margin: 1cm;
    size: auto;
  }
  ul {
    list-style: none;
    padding-left: 0px;
  }
  .btn_no_hover {
    &:hover,
    &[disabled]:hover {
      box-shadow: none !important;
      background: transparent !important;
    }
  }
  @media (max-width: 668px), (max-height: 412px), (max-width: 1500px) and (min-width: 769px), (max-width: 1024px) {
    :root {
      font-size: 7px;
    }
  }
  /* common text style */
  span{
    &.block-centered{
      position: relative;
      display: block;
      width: 100%;
      text-align: center;
      padding: 20px;
      font-size: 20px
    }
  }
  .wagi-warning {
    color: ${variables.colorDecorator};
    svg {
      fill: ${variables.colorMainText};
      width: 2rem;
      height: 2rem;
    }
  }
  .cell_bold {
    font-weight: 900;
  }
  .custom_calendar {
    .ant-picker-footer a.ant-picker-today-btn {
      color: ${variables.colorDecorator};
      font-size: 2rem;
    }
    div.ant-picker-cell-inner,
    table.ant-picker-content thead tr td,
    .ant-picker-header button {
      font-size: 2rem;
    }
    td.ant-picker-cell-in-view div.ant-picker-cell-inner {
      color: ${variables.colorMainText};
    }
    td.ant-picker-cell-in-view.ant-picker-cell-today div.ant-picker-cell-inner::before {
      border-color: ${variables.colorDecorator};
    }
    .ant-picker-cell div.ant-picker-cell-inner {
      min-width: 26px;
      min-height: 26px;
      line-height: 26px;
    }
    .ant-picker-header button:hover {
      color: ${variables.colorDecorator};
    }
    td.ant-picker-cell-in-view.ant-picker-cell-selected div.ant-picker-cell-inner {
      border-color: ${variables.colorDecorator};
      background-color: ${variables.colorDecorator};
      color: ${variables.colorWhite};
    }
  }
  .custom_dropdown {
    border-radius: 6px;
    div::-webkit-scrollbar {
      width: 4px;
      height: 4px;
      border-color: ${variables.colorWhite};
      background: ${variables.colorBorder};
    }
    div::-webkit-scrollbar-thumb {
      background: ${variables.colorDecorator};
    }
    span.anticon-check {
      color: ${variables.colorDecorator};
    }

  }
  .custom_select span.ant-select-selection-item,
  .custom_select .ant-select-selection-placeholder,
  .custom_select .ant-select-selection-search-input,
  .custom_dropdown div.ant-select-item-option.custom_option {
    font-size: 2rem;
    font-family: ${variables.fontText};
    color: ${variables.colorMainText};
    display: flex;
  }
  .custom_select {
    span.anticon-close {
      margin-left: 8px;
      color: ${variables.colorDecorator};
    }
    &:hover:not(.ant-select-disabled) div.ant-select-selector {
      border-color: ${variables.colorDecorator};
    }
    &.ant-select-focused div.ant-select-selector:not(.ant-select-disabled) {
      box-shadow: none;
      border-color: ${variables.colorDecorator};
    }
    .ant-select-arrow {
      color: ${variables.colorDecorator};
    }
  }
  .ant-tabs-tabpane.no-scroll {
    overflow: hidden;
  }
  .relative {
    position: relative;
  }
  .custom_dropdown div.ant-select-item-option-active.custom_option {
    background-color: ${variables.colorBackground};
  }
  .custom_dropdown div.ant-select-item-option-selected.custom_option {
    background-color: ${variables.colorBorder};
  }
  .custom_dropdown .ant-select-item-option-disabled {
    opacity: 0.5;
  }
  .loader__centered {
    position: absolute;
    left: 49%;
    font-size: 32px;
  }
  .custom__transfer {
    .ant-transfer-list {
      height: 600px;
      overflow: hidden;
    }
    .ant-transfer-list-header-title {
      font-weight: 600;
    }
    .ant-transfer-list-body-customize-wrapper::-webkit-scrollbar {
      width: 4px;
      height: 4px;
      border-color: ${variables.colorWhite};
      background: ${variables.colorBorder};
    }
    .ant-transfer-list-body-customize-wrapper::-webkit-scrollbar-thumb {
      background: ${variables.colorDecorator};
    }
    .ant-transfer-list-body-customize-wrapper {
      max-height: 500px;
      padding: 8px 4px;
      overflow: auto;
    }
    input.ant-input {
      color: ${variables.colorMainText};
      &:hover {
        border: 1px solid ${variables.colorDecorator};
      }
      &::placeholder {
        color: ${variables.colorMainText};
      }
      span.anticon {
        color: ${variables.colorDecorator};
      }
    }

  .ant-input:focus, .ant-input-focused {
    border-color: ${variables.colorDecorator};
    box-shadow: 0 0 0 2px rgba(139,35,29, 0.1);
  }
  @media(max-width: 768px) {
    display: flex;
    flex-direction: column;
    .ant-transfer-operation {
      display: flex;
      justify-content: center;
      margin: 10px 0;
    }
    span.anticon-right, span.anticon-left {
      transform: rotate(90deg);
    }
  }
  }
  .custom_popconfirm {
    div.ant-popover-message div.ant-popover-message-title {
      font-size: 2rem;
      color: ${variables.colorMainText};
    }
    div.ant-popover-message > .anticon {
      top: 14px;
    }
    div.ant-popover-buttons button {
      text-transform: uppercase;
      cursor: pointer;
      padding: 0px 24px;
      border-color: ${variables.colorDecorator};
      border-radius: 21px;
      font-weight: 600;
      box-shadow: none;
    }
    div.ant-popover-buttons button.ant-btn-primary {
      background: ${variables.colorDecorator};
      color: ${variables.colorWhite};
    }
    div.ant-popover-buttons button:not(.ant-btn-primary) {
      &:hover {
        color: ${variables.colorDecorator};
      }
    }
  }
.modal__responsive {
  min-width: 70%;
  max-width: 85%;
  @media(max-width: 768px) {
    min-width: 90%;
    max-width: unset;
  }
}
.icon_trash {
  filter: brightness(0);
}

::-webkit-scrollbar {
    width: 6px;
    border-color: ${variables.colorWhite};
    background: ${variables.colorWhite};
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar-thumb {
    background: ${variables.colorGrey};
    border-radius: 8px;

    &:hover {
      background: ${variables.colorGreyDarkest};
      border-radius: 8px;
    }

    &:active {
      background: ${variables.colorDecorator};
      border-radius: 8px;
    }
  }
`;
